import React from "react";
//#region types
import { FormRowProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import InlineFormControl from "./inlineFormControl";
import VerticalFormControl from "./verticalFormControl";
//#endregion

function FormRow<T extends Record<string, any>>(props: FormRowProps<T>) {
  return props.inline ? <InlineFormControl<T> {...props} /> : <VerticalFormControl<T> {...props} />;
}

export default FormRow;
